/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@compiled/react';

import { fg } from '@atlaskit/platform-feature-flags';

import {
	ResizableNativeEmbedCoordinator,
	type ResizableNativeEmbedCoordinatorProps,
} from './ResizableNativeEmbedCoordinator';
import { ResizableNativeEmbedLegacy } from './ResizableNativeEmbedLegacy';

export const resizerNextTestId = 'nativeEmbed.resizerNext.testid';

export type ResizableNativeEmbedProps = ResizableNativeEmbedCoordinatorProps;

export const ResizableNativeEmbed = (props: ResizableNativeEmbedProps): JSX.Element => {
	if (fg('platform_native_embeds_one_percent_rollout_bugfix')) {
		// eslint-disable-next-line react/jsx-props-no-spreading -- thin FG-switch wrapper
		return <ResizableNativeEmbedCoordinator {...props} />;
	}
	// eslint-disable-next-line react/jsx-props-no-spreading -- thin FG-switch wrapper
	return <ResizableNativeEmbedLegacy {...props} />;
};
